/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import Form from "@components/shared/form";
import { useQuery } from "@tanstack/react-query";
import { GQLPosts } from "@gql/types/gql";
import OfferList from "./offerList";
import ListOfLinks from "@components/shared/listOfLinks";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";

export default function BestOverAll() {
    const { data: recentPosts } = useQuery<GQLPosts[], Error>([
        "recentPostsByCategory",
    ]);
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <section className="lg:px-0 mt-9 lg:mt-0">
            <OfferList />
            <Form shouldSplit />
            {(recentPosts?.length as number) > 0 && (
                <ListOfLinks
                    title={translate(
                        translations,
                        "several_general_readInOurBlog",
                    )}
                    items={recentPosts as { title: string; link: string }[]}
                />
            )}
        </section>
    );
}
